import React from 'react';
import { arrayOf, bool, func, oneOfType, shape, string } from 'prop-types';
import { Box } from '@mui/material';

import { Select } from '../../../../../../../components';

const Frequency = ({
  inputName, children, handleChange, inputValues, disabled,
}) => {
  const handleFrequencyChange = (event) => {
    const { name, value } = event.target;
    handleChange({ key: inputName, value: { [name]: value } });
  };

  const handleRateChange = (event) => {
    const { name, value } = event.target;
    handleChange({ key: inputName, value: { ...inputValues, [name]: value } });
  };

  const renderRateDropdown = () => {
    if (!inputValues.frequency || !children) return null;


    const rateOptions = children.find(el => el.name === inputValues.frequency);
    if (!rateOptions || !rateOptions.children) return null;
    return (
      <Select
        id="frequency-rate-select"
        name={inputValues.frequency}
        value={inputValues[inputValues.frequency]}
        onChange={handleRateChange}
        options={rateOptions.children.slice(1).map(({ name, text }) => ({
          value: name,
          label: text,
        }))}
        disabled={disabled}
        selectStyles={{ width: '260px' }}
        placeholderOptionLabel={rateOptions.children[0].text}
      />
    );
  };

  return (
    <Box display="flex" gap={1}>
      <Select
        id="frequency-select"
        name={inputName}
        value={inputValues.frequency}
        onChange={handleFrequencyChange}
        options={children.slice(1).map(({ name, text }) => ({
          value: name,
          label: text,
        }))}
        selectStyles={{ width: '260px' }}
        placeholderOptionLabel={children[0].text}
        disabled={disabled}
      />
      {renderRateDropdown()}
    </Box>
  );
};

export default Frequency;

Frequency.propTypes = {
  inputName: string.isRequired,
  children: arrayOf(
    shape({
      name: string,
    }),
  ),
  handleChange: func.isRequired,
  inputValues: oneOfType([
    string,
    shape({
      frequency: string,
    }),
  ]),
  disabled: bool.isRequired,
};

Frequency.defaultProps = {
  inputValues: {},
  children: [],
};
